import { Button } from "react-aria-components";
import { globalUpdateResultsSignal, globalSubmittingSignal } from "../../Layout";
import { useEffect, useState } from "react";
import { UserStatusSmartEnum } from "../../../../../enums/Domain/UserStatusSmartEnum";
import sendBlockRequest from "../../../../../modules/apis/BlockApi";
import { SingularUpperCase } from "../../../../../helpers/EntityNameHelper";
import ConfirmModal from "../../../Modal/ConfirmModal";
import { modalSignal } from "../../../Modal/ModalContainer";
import { StatusDto } from "../../../../../enums/Domain/Status";
import { EntityNames } from "../../../../../enums/EntityNames";
import { OperatorStatusSmartEnum } from "../../../../../enums/Domain/OperatorStatusSmartEnum";

interface IBlockActionProps {
    data: any
}

export default function BlockUserAction(props: IBlockActionProps) {
    const { data } = props;
    const [alreadyBlocked, setAlreadyBlocked] = useState<boolean | undefined>()

    useEffect(() => {
        if (data) {
            const blockedValue = data.entityName === EntityNames.operators
                ? OperatorStatusSmartEnum.IsInactive.value
                : UserStatusSmartEnum.IsInactive.value;

            setAlreadyBlocked(data.status.value === blockedValue);
        }
    }, [data])

    async function handleBlock() {
        const result = await sendBlockRequest(data.entityName, data.id)
        if (result === true) {
            // Toggle the blocked state
            const newBlockedState = !alreadyBlocked;
            setAlreadyBlocked(newBlockedState);

            const blockedValue = data.entityName === EntityNames.operators
                ? OperatorStatusSmartEnum.IsInactive.value
                : UserStatusSmartEnum.IsInactive.value;

            const enumName = data.entityName === EntityNames.operators
                ? OperatorStatusSmartEnum.getName()
                : UserStatusSmartEnum.getName();

            // Update status based on new blocked state
            const newStatusValue = newBlockedState ? blockedValue : 
                (data.entityName === EntityNames.operators 
                    ? OperatorStatusSmartEnum.IsActive.value 
                    : UserStatusSmartEnum.IsActive.value);

            globalUpdateResultsSignal.value = {
                id: data.id,
                updateChanges: {
                    status: new StatusDto(newStatusValue, enumName),
                }
            }
        }
    }

    function handleConfirmBlock() {
        const isBlocking = !alreadyBlocked;
        const heading = isBlocking 
            ? `Deactivate ${SingularUpperCase(data.entityName)}?`
            : `Activate ${SingularUpperCase(data.entityName)}?`;
        
        const information = isBlocking
            ? "This will take immediate effect, and terminate the user's current login session."
            : "This will allow the user to regain access to the system. This will take immediate effect.";

        modalSignal.value = <ConfirmModal
            heading={heading}
            information={information}
            ContinueFunc={async () => { await handleBlock() }} />
    }

    const buttonText = alreadyBlocked ? "Activate" : "Deactivate";
    const buttonClassName = alreadyBlocked 
        ? "button button--small button--primary button--with-icon"
        : "button button--small button--primary button--primary--destructive button--with-icon";

    return alreadyBlocked !== undefined ?
        <Button 
            isDisabled={globalSubmittingSignal.value.isBusy} 
            className={buttonClassName} 
            onPress={handleConfirmBlock}>
            <p className="button-text">{buttonText}</p>
        </Button> : <></>
}